// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-status {
  gap: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(20, 46, 82, 0.2);
  min-height: 70px;
  padding: 10px 15px;
  position: relative;
  margin-bottom: 15px;
  background-color: var(--sebrae-white);
  display: flex;
}
.card-status .content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.card-status:before {
  content: "";
  width: 5px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #9285f9;
  border-radius: 8px 0 0 8px;
}
.card-status.completed:before {
  background: #84f4bc;
}
.card-status.disabled {
  opacity: 0.7;
  cursor: no-drop;
  pointer-events: none;
}
.card-status h5 {
  color: #243342;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
}
.card-status p {
  color: #617385;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.card-status .open-options {
  border-radius: 50%;
  padding: 3px;
  transition: 0.3s;
}
.card-status .open-options:hover {
  background-color: #f1f1f1;
}
.card-status .options {
  position: absolute;
  right: 8px;
  top: 56px;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  padding: 15px;
  z-index: 1;
  transition: 0.3s;
  display: none;
  align-items: center;
}
.card-status .options:before {
  content: "";
  position: absolute;
  top: -18px;
  right: 9px;
  border-bottom: 10px solid #ffffff;
  border-top: 10px solid transparent;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}
.card-status .options.open {
  display: flex;
}
.card-status .options ul li {
  padding-bottom: 15px;
}
.card-status .options ul li .link {
  display: flex;
  align-items: center;
  gap: 12px;
}
.card-status .options ul li:last-child {
  padding-bottom: 0;
}
.card-status .options ul li a {
  text-decoration: none;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/card-status/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAEE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,0BAAA;AAAJ;AAII;EACE,mBAAA;AAFN;AAME;EACE,YAAA;EACA,eAAA;EACA,oBAAA;AAJJ;AAOE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALJ;AAQE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANJ;AASE;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AAPJ;AASI;EACE,yBAAA;AAPN;AAWE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AATJ;AAWI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EACA,mCAAA;AATN;AAYI;EACE,aAAA;AAVN;AAcM;EACE,oBAAA;AAZR;AAaQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAXV;AAcQ;EACE,iBAAA;AAZV;AAeQ;EACE,qBAAA;EACA,cAAA;AAbV","sourcesContent":[".card-status {\n  gap: 20px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px 0 rgba(20, 46, 82, 0.2);\n  min-height: 70px;\n  padding: 10px 15px;\n  position: relative;\n  margin-bottom: 15px;\n  background-color: var(--sebrae-white);\n  display: flex;\n\n  .content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n\n  &:before {\n    content: \"\";\n    width: 5px;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    background: #9285f9;\n    border-radius: 8px 0 0 8px;\n  }\n\n  &.completed {\n    &:before {\n      background: #84f4bc;\n    }\n  }\n\n  &.disabled {\n    opacity: 0.7;\n    cursor: no-drop;\n    pointer-events: none;\n  }\n\n  h5 {\n    color: #243342;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 23.3px;\n  }\n\n  p {\n    color: #617385;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n\n  .open-options {\n    border-radius: 50%;\n    padding: 3px;\n    transition: 0.3s;\n\n    &:hover {\n      background-color: #f1f1f1;\n    }\n  }\n\n  .options {\n    position: absolute;\n    right: 8px;\n    top: 56px;\n    background: #ffffff;\n    box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n    padding: 15px;\n    z-index: 1;\n    transition: 0.3s;\n    display: none;\n    align-items: center;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: -18px;\n      right: 9px;\n      border-bottom: 10px solid #ffffff;\n      border-top: 10px solid transparent;\n      border-right: 10px solid transparent;\n      border-left: 10px solid transparent;\n    }\n\n    &.open {\n      display: flex;\n    }\n\n    ul {\n      li {\n        padding-bottom: 15px;\n        .link {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n        }\n\n        &:last-child {\n          padding-bottom: 0;\n        }\n\n        a {\n          text-decoration: none;\n          color: inherit;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
